<template>
  <el-container class="ProductBulkChange">
    <el-main class="p-0">
      <el-form
        ref="form"
        class="form-label-80"
        label-width="80px"
        :model="data"
        :rules="rules"
      >
        <el-form-item prop="type_id" :label="$t('lang.product_type')">
          <el-checkbox v-model="selection.type_id" />
          <AProductTypeSelector
            v-model="data.type_id"
            class="pl-default"
            :placeholder="$t('lang.product_type')"
            @change="handleChangeTypeId"
          />
        </el-form-item>
        <el-form-item
          prop="sale_type_id"
          :label="$t('lang.sales_classification')"
        >
          <el-checkbox v-model="selection.sale_type_id" />
          <el-select
            v-model="data.sale_type_id"
            class="pl-default"
            :placeholder="$t('lang.sales_classification')"
            @change="handleChangeSaleTypeId"
          >
            <el-option
              v-for="item in table_sale_type"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="제품구분" prop="categories">
          <el-checkbox v-model="selection.categories" />
          <el-select
            v-model="data.categories"
            class="pl-default"
            multiple
            :placeholder="$t('lang.categories')"
            @change="handleChangeCategories"
          >
            <el-option
              v-for="item in table_product_category"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="unit_id" :label="$t('lang.unit')">
          <el-checkbox v-model="selection.unit_id" />
          <el-select
            v-model="data.unit_id"
            class="pl-default"
            :placeholder="$t('lang.unit')"
            @change="handleChangeUnitId"
          >
            <el-option
              v-for="item in table_unit"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="is_hide" label="숨기기">
          <el-checkbox
            v-model="selection.is_hide"
            @change="handleHideProduct"
          />
          <el-radio-group v-model="data.is_hide" class="pl-default">
            <el-radio-button label="Y">숨김</el-radio-button>
            <el-radio-button label="N">보임</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="is_hide" label="재고관리">
          <el-checkbox
            v-model="selection.is_manage_stock"
            @change="handleManageStock"
          />
          <el-radio-group v-model="data.is_manage_stock" class="pl-default">
            <el-radio-button label="Y">사용</el-radio-button>
            <el-radio-button label="N">미사용</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['F4']"
        :disabled="disableRegister || !has_grant_write"
        :loading="load_button"
        @shortkey.native="handleClickRegister"
        @click="handleClickRegister"
        >{{ $t("button.register") }}(F4)</el-button
      >
      <el-button class="close-button" @click="handleCloseDialog"
        >{{ $t("button.close") }}(Esc)</el-button
      >
    </el-footer>
  </el-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ProductBulkChange",
  data() {
    let validateTypeId = (rule, value, callback) => {
      if (!this.selection.type_id || this.data.type_id) {
        callback();
      } else {
        callback(new Error("품목구분을 선택해 주세요."));
      }
    };
    let validateSaleTypeId = (rule, value, callback) => {
      if (!this.selection.sale_type_id || this.data.sale_type_id) {
        callback();
      } else {
        callback(new Error("판매구분을 선택해 주세요."));
      }
    };
    let validateUnitId = (rule, value, callback) => {
      if (!this.selection.unit_id || this.data.unit_id) {
        callback();
      } else {
        callback(new Error("단위를 선택해 주세요."));
      }
    };
    let validateCategories = (rule, value, callback) => {
      if (!this.selection.categories || this.data.categories.length > 0) {
        callback();
      } else {
        callback(new Error("제품구분을 선택해 주세요."));
      }
    };
    let validateIsHide = (rule, value, callback) => {
      if (!this.selection.is_hide || this.data.is_hide) {
        callback();
      } else {
        callback(new Error("숨기기 옵션을 선택해 주세요."));
      }
    };
    let validateIsManageStock = (rule, value, callback) => {
      if (!this.selection.is_manage_stock || this.data.is_manage_stock) {
        callback();
      } else {
        callback(new Error("재고관리 옵션을 선택해 주세요."));
      }
    };
    return {
      title: this.$t("title.product"),
      selection: {
        type_id: false,
        sale_type_id: false,
        unit_id: false,
        categories: false,
        is_hide: false,
        is_manage_stock: false,
      },
      data: {
        type_id: null,
        sale_type_id: null,
        unit_id: null,
        categories: [],
        is_hide: null,
        is_manage_stock: null,
      },
      rules: {
        type_id: [{ validator: validateTypeId, trigger: "blur" }],
        sale_type_id: [{ validator: validateSaleTypeId, trigger: "blur" }],
        unit_id: [{ validator: validateUnitId, trigger: "blur" }],
        categories: [{ validator: validateCategories, trigger: "blur" }],
        is_hide: [{ validator: validateIsHide, trigger: "blur" }],
        is_manage_stock: [
          { validator: validateIsManageStock, trigger: "blur" },
        ],
      },
      load_button: false,
    };
  },
  props: {
    ids: {
      type: Array,
      required: true,
    },
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["table_product_category", "table_unit", "table_sale_type"]),
    disableRegister() {
      return (
        !this.selection.type_id &&
        !this.selection.sale_type_id &&
        !this.selection.unit_id &&
        !this.selection.categories &&
        !this.selection.is_hide &&
        !this.selection.is_manage_stock
      );
    },
  },
  methods: {
    doRegister() {
      let data = {};
      if (this.selection.type_id) {
        data.type_id = this.data.type_id;
      }
      if (this.selection.sale_type_id) {
        data.sale_type_id = this.data.sale_type_id;
      }
      if (this.selection.unit_id) {
        data.unit_id = this.data.unit_id;
      }
      data.categories = [];
      if (this.selection.categories) {
        for (let i = 0; i < this.data.categories.length; i++) {
          let obj = {};
          obj.product_category_id = Object.assign(this.data.categories[i]);
          data.categories[i] = obj;
        }
      }
      if (this.selection.is_hide) {
        data.is_hide = this.data.is_hide;
      }
      if (this.selection.is_manage_stock) {
        data.is_manage_stock = this.data.is_manage_stock;
      }
      let param = {
        ids: this.ids,
        data: data,
      };
      this.load_button = true;
      this.api.updateProductBulk(param).then((res) => {
        this.load_button = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.util.notify_success(this, this.title, "등록되었습니다.");
        this.$emit("completed");
      });
    },
    handleChangeTypeId() {
      this.selection.type_id = !!this.data.type_id;
    },
    handleChangeSaleTypeId() {
      this.selection.sale_type_id = !!this.data.sale_type_id;
    },
    handleChangeUnitId() {
      this.selection.unit_id = !!this.data.unit_id;
    },
    handleChangeCategories() {
      this.selection.categories = !!this.data.categories;
    },
    handleHideProduct(v) {
      this.selection.is_hide = v;
    },
    handleManageStock(v) {
      this.selection.is_manage_stock = v;
    },
    handleClickRegister() {
      if (!this.has_grant_write) return;

      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.doRegister();
      });
    },
    handleCloseDialog() {
      this.$emit("completed");
    },
  },
};
</script>
